<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Transporte de productos</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item active">Productos</li>
        <li class="breadcrumb-item active">Transporte</li>
      </ol>
    </div>
    <div v-if="isloading==true" class="card">
      <div class="card-header">
        <button class="btn btn-theme" @click="cerrar">Cerrar</button>
        <br>
        <br>
        <div class="form-group">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Documento</strong> </label>
                <p v-text="transport.document.name"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>No. de transporte</strong> </label>
                <p v-text="transport.ticket_number"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Empleado</strong> </label>
                <p v-text="transport.employee.person.name"/>
                <!-- <p v-text="formatQuetzales(account.amount)"/> -->
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Fecha</strong> </label>
                <p v-text="transport.transportDate"/>
              </div>
            </div>
            <!-- <div v-else class="col-md-3">
              <div class="form-group">
                <label><strong>Banco</strong> </label>
                <p v-text="account.bank.name"/>
              </div>
            </div> -->
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Envia</strong> </label>
                <p v-text="transport.place_send.name"/>
                <!-- <p v-text="mostrarArray(account.places)"/> -->
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Recibe</strong> </label>
                <p v-text="transport.place_rece.name"/>
                <!-- <p v-text="mostrarArray(account.payments)"/> -->
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Descripción</strong> </label>

                <p v-if="transport.description==null">Sin descripción</p>
                <p v-else v-text="transport.description" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Estado</strong> </label>
                <br>
                <span v-if="transport.state==0" class="btn btn-danger btn-sm">Cancelado</span>
                <span v-else-if="transport.state==1" class="btn btn-info btn-sm">Pendiente</span>
                <span v-else-if="transport.state==2" class="btn btn-success btn-sm">Completo</span>
                <span v-else-if="transport.state==3" class="btn btn-warning btn-sm">Incompleto</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group">
              <label>Productos</label>
              <table-component :data="detailTransactionsArray" :show-filter="false" table-class="table">
                <table-column show="amount" label="cantidad enviada" />
                <table-column v-if="transport.state==1" :sortable="false" :filterable="false" label="Cantida que llegó">
                  <template slot-scope="row">
                    <input
                      v-if="row['state']==0"
                      v-model.number="detailTransactionsArray[getIndex(detailTransactionsArray,row['id'])].arrivedAmount"
                      :class="{ 'is-invalid': detailTransactionsArray[getIndex(detailTransactionsArray,row['id'])].error===true }"
                      :ref="'arrivedAmount-'+getIndex(detailTransactionsArray,row['id'])"
                      disabled
                      type="number"
                      class="form-control"
                      @blur="validateQuantity(getIndex(detailTransactionsArray,row['id']))"
                    >
                    <input
                      v-else
                      v-model.number="detailTransactionsArray[getIndex(detailTransactionsArray,row['id'])].arrivedAmount"
                      :class="{ 'is-invalid': detailTransactionsArray[getIndex(detailTransactionsArray,row['id'])].error===true }"
                      :ref="'arrivedAmount-'+getIndex(detailTransactionsArray,row['id'])"
                      type="number"
                      class="form-control"
                      @blur="validateQuantity(getIndex(detailTransactionsArray,row['id']))"
                    >
                  </template>
                <!-- @keyup.enter="refMultiple('quantity',getIndexPlus(selectProducts,row['id']))" > -->
                </table-column>
                <table-column v-else :sortable="false" :filterable="false" show="arrivedAmount" label="Cantida que llegó"/>
                <table-column show="stocksend.product.name" label="Producto" />
                <table-column show="stocksend.measure.equal" label="Medida" />
                <table-column :sortable="false" :filterable="false" label="Estado">
                  <template slot-scope="row">
                    <div v-if="transport.state==0">
                      <span class="btn btn-danger">Cancelado</span>
                    </div>
                    <div v-else>
                      <span v-if="row['state']==1" class="btn btn-info">Llegó</span>
                      <span v-else-if="row['state']==2" class="btn btn-warning">Incompleto</span>
                      <span v-else class="btn btn-danger">No llegó</span>
                    </div>
                  </template>
                </table-column>
                <table-column :sortable="false" :filterable="false" label="Acciones">
                  <template slot-scope="row">
                    <div v-if="transport.state==1">
                      <button v-tooltip.top-center="'El producto no llegó'" v-if="row['state']==1" class="btn btn-warning" @click="openModal('didnt',row['id'])"><i
                        class="icon-fa icon-fa-ban" />
                      </button>
                      <button v-tooltip.top-center="'El producto si llegó'" v-else class="btn btn-info" @click="openModal('did', row['id'])"><i
                        class="icon-fa icon-fa-check" />
                      </button>
                    </div>
                  </template>
                </table-column>
              </table-component>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <div class="col-md-12">
              <button
                v-if="transport.state==1"
                slot="button"
                type="button"
                class="btn btn-success"
                @click="openModal('shipment')"
              > Completar envio </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <sweet-modal
      ref="activate_modal"
      icon="info"
      hide-close-button
      blocking
    >
      {{ modalTitleActivate }}
      <button
        slot="button"
        type="button"
        class="btn btn-info"
        @click="$refs.activate_modal.close()"
      >No</button>
      <button
        v-if="typeAction == 1"
        slot="button"
        type="button"
        class="btn btn-danger"
        @click="productDidntArrive(id)"
      >Si</button>
      <button
        v-if="typeAction == 2"
        slot="button"
        type="button"
        class="btn btn-danger"
        @click="productDidArrive(id)"
      >Si</button>
      <button
        v-if="typeAction == 3"
        slot="button"
        type="button"
        class="btn btn-success ladda-button"
        data-style="expand-right"
        @click="saveShipment()"
      >Si</button>
    </sweet-modal>
  </div>
</template>
<script>
import { SweetModal } from 'sweet-modal-vue'
import { TableComponent, TableColumn } from 'vue-table-component'
import ladda from 'ladda'
export default {
  components: {
    SweetModal,
    TableComponent,
    TableColumn
  },
  data () {
    return {
      id: '',
      typeAction: 0,
      modalTitleActivate: '',
      transport: {},
      detailTransactionsArray: [],
      isloading: false,
      pagination: {
        'total': 0,
        'current_page': 0,
        'per_page': 0,
        'last_page': 0,
        'from': 0,
        'to': 0
      },
      offset: 3,
      search: ''
      // photoTrans: ''
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + (this.offset * 2)
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    // console.log(this.$route.query.item)
    this.getTransport(this.$route.query.item)
    // this.fetchData(1, this.$route.query.item)
  },
  methods: {
    getTransport (id) {
      let me = this
      axios.get(`/api/admin/transport/getTransport?id=${id}`)
        .then(function (response) {
          // console.log(response)
          me.transport = response.data
          me.detailTransactionsArray = me.transport.detail_transport
          me.isloading = true
          // console.log(me.detailTransactionsArray)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    changePage (page) {
      let me = this
      // Actualiza la página actual
      me.pagination.current_page = page
      // Envia la petición para visualizar la data de esa página
      me.fetchData(page, this.transport.id)
    },
    async fetchData (page, item) {
      let me = this
      const response = await axios.get(
        `/api/admin/detailTransaction/searchTransactions?page=${page}&item=${item}`
      )
        .then(function (response) {
          var respuesta = response.data
          me.transactionsArray = respuesta.transactions.data
          me.pagination = respuesta.pagination
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // mostrarArray (item) {
    //   if (item == undefined) {
    //     // console.log('se chingo')
    //   } else {
    //     var letra = ''
    //     item.forEach(element => {
    //       letra = letra + ', ' + element.name
    //       // letra += element.name + ''
    //     })
    //     letra = letra.substring(2, letra.length)
    //     return letra
    //   }
    // },
    formatQuetzales (amount) {
      var num = parseFloat(amount), formatted
      formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      return amount = 'Q ' + formatted
    },
    transportNull () {
      if (this.transport == undefined) {
        // console.log(true)
      } else {
        this.getTransport(this.$route.query.item)
      }
    },
    getIndex (list, id) {
      return list.findIndex((e) => e.id == id)
    },
    productDidntArrive (id) {
      // console.log(id)
      let me = this
      axios
        .patch('/api/admin/transport/productDidntArrive', {
          id: id
        })
        .then(function (response) {
          // console.log(response)
          toastr.success(response.data.message, 'Listo')
          me.closeModal()

          // console.log(me.detailTransactionsArray[me.getIndex(me.detailTransactionsArray, id)].arrivedAmount)
          // Aqui volver a listar todo
        })
        .catch(function (error) {
          toastr.error(error.response.data.message, 'Error')
        })
    },
    productDidArrive (id) {
      let me = this
      axios
        .patch('/api/admin/transport/productDidArrive', {
          id: id
        })
        .then(function (response) {
          // console.log(response)
          toastr.success(response.data.message, 'Listo')
          me.closeModal()
          // Aqui volver a listar todo
        })
        .catch(function (error) {
          toastr.error(error.response.data.message, 'Error')
        })
    },
    productDidArriveIncomplete (id) {
      let me = this
      axios
        .patch('/api/admin/transport/productDidArriveIncomplete', {
          id: id,
          newAmount: this.detailTransactionsArray[this.getIndex(this.detailTransactionsArray, id)].arrivedAmount
        })
        .then(function (response) {
          // console.log(response)
          toastr.success(response.data.message, 'Listo')
          me.closeModal()
          // Aqui volver a listar todo
        })
        .catch(function (error) {
          toastr.error(error.response.data.message, 'Error')
        })
    },
    openModal (accion, data = []) {
      let me = this
      switch (accion) {
        case 'didnt': {
          me.$refs.activate_modal.open()
          this.modalTitleActivate = '¿Está seguro de que el producto no llegó?'
          this.typeAction = 1
          this.id = data
          // console.log(this.id)
          break
        }
        case 'did': {
          me.$refs.activate_modal.open()
          this.modalTitleActivate = '¿Está seguro de que el producto si llegó?'
          this.typeAction = 2
          this.id = data
          break
        }
        case 'shipment': {
          me.$refs.activate_modal.open()
          this.modalTitleActivate = '¿Está seguro de que todo el producto si llegó?'
          this.typeAction = 3
          break
        }
      }
    },
    closeModal () {
      this.$refs.activate_modal.close()
      this.getTransport(this.$route.query.item)
      // this.cerrar()
    },
    saveShipment () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      let me = this
      l.start()
      axios
        .post('/api/admin/transport/shipment', {
          transport: this.transport.id,
          product: this.detailTransactionsArray
        })
        .then(function (response) {
          // console.log(response)
          toastr.success(response.data.message, 'Listo')
          l.stop()
          me.cerrar()
        })
        .catch(function (error) {
          l.stop()
          console.log(error)
          toastr.error(error.response.data.message, 'Error')
        })
    },
    validateQuantity (item) {
      if (typeof (this.detailTransactionsArray[item].arrivedAmount) !== 'undefined') {
        if (this.detailTransactionsArray[item].arrivedAmount > this.detailTransactionsArray[item].amount) {
          this.detailTransactionsArray[item].arrivedAmount = this.detailTransactionsArray[item].amount
          toastr.error('Existencia insuficiente', 'Error')
          // this.refMultiple('quantity', item);
        } else if (this.detailTransactionsArray[item].arrivedAmount < 0) {
          this.detailTransactionsArray[item].arrivedAmount = 1
          toastr.error('La cantidad debe ser al menos 1', 'Error')
          // this.refMultiple('quantity', item)
        } else if (this.detailTransactionsArray[item].arrivedAmount == 0) {
          this.productDidntArrive(this.detailTransactionsArray[item].id)
        } else if (this.detailTransactionsArray[item].arrivedAmount == this.detailTransactionsArray[item].amount) {
          this.productDidArrive(this.detailTransactionsArray[item].id)
        } else if (this.detailTransactionsArray[item].arrivedAmount > 0 && this.detailTransactionsArray[item].arrivedAmount < this.detailTransactionsArray[item].amount) {
          this.productDidArriveIncomplete(this.detailTransactionsArray[item].id)
        }
      }
    },
    cerrar () {
      this.$router.push({
        name: 'transport'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/transport/Shipment.vue